module.exports = __webpack_public_path__ + "img/Lumina_closed.6230ac99.png";